{
  "dss": {
    "button": {
      "back": "Natrag",
      "cancel": "Otkaži",
      "close": "Zatvori",
      "confirmDelete": "Da, izbriši",
      "continue": "Nastavi",
      "logout": "Odjava",
      "passwordReset": "Poništavanje lozinke",
      "save": "Spremi",
      "verify": "Potvrdi"
    },
    "error": {
      "403": "Nemate pristup ovoj stranici.",
      "404": "Tražena stranica nije pronađena.",
      "generic": "Došlo je do pogreške. Pokušajte ponovno kasnije.",
      "throttling": "Previše pokušaja. Ova je operacija privremeno blokirana.",
      "title": "Pogreška",
      "title403": "Pristup odbijen",
      "title404": "Stranica nije pronađena"
    },
    "footer": {
      "imprint": "Impressum",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Pravila privatnosti",
      "terms": "Uvjeti korištenja"
    },
    "label": {
      "CRMAccountNumber": "CRM broj računa",
      "contact": "Kontakt",
      "email": "E-mail",
      "faq": "ČPP",
      "female": "Gđa",
      "firstname": "Ime",
      "help": "Pomoć",
      "language": "Jezik",
      "lastname": "Prezime",
      "male": "Gdin",
      "needHelp": "Trebaš pomoć?",
      "newPassword": "Nova lozinka",
      "newPassword2": "Potvrdi novu lozinku",
      "oldPassword": "Trenutna lozinka",
      "organization": "Organizacija",
      "password": "Lozinka",
      "required": "Obavezno polje",
      "salutation": "Pozdrav",
      "select": "Molimo odaberite"
    },
    "lang": {
      "de": "Njemački"
    },
    "link": {
      "contact": "https://support.stihl.com/hr-HR/websso-contact/",
      "faq": "https://support.stihl.com/hr-HR/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Potvrdi registraciju",
        "wait": "Pričekajte završetak potvrde računa."
      },
      "otp": {
        "btnResend": "Pošalji ponovno e-poruku s kodom za potvrdu",
        "msg": {
          "invalidOTP": "Unesena jednokratna lozinka nije valjana.",
          "resendFail": "Ponovno slanje koda nije uspjelo. Pokušajte kasnije."
        },
        "spamDetail": "Provjerite pristiglu poštu i neželjenu poštu za e-poruku od STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Niste dobili e-poruku?",
        "subtitle": "Za nastavak trebate potvrditi svoju e-mail adresu.",
        "title": "Potvrdite svoj korisnički račun",
        "txtVerifyMail": "Unesite novi verifikacijski kod koji smo poslali na vašu adresu e-pošte {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Nema ništa za ažurirati.",
          "updateError": "Neuspjelo ažuriranje osobnih podataka.",
          "updated": "Osobni podaci su ažurirani.",
          "userLoadErr": "Pogreška pri učitavanju podataka korisnika. Pokušajte kasnije."
        },
        "secOrganization": "Organizacija",
        "secPersonal": "Osobno",
        "secSettings": "Preferirane postavke",
        "title": "Osobni podaci"
      },
      "postPwSet": {
        "info": "Sada možete koristiti novu lozinku.",
        "link_name": "Nastavi na Self-Service",
        "link_url": "/user/ui/",
        "title": "Vaša lozinka je promijenjena"
      },
      "resetPW": {
        "title": "Poništite svoju lozinku"
      },
      "security": {
        "2fa": {
          "availableMethods": "Dostupne 2FA metode:",
          "info": "Dvofaktorska autentikacija (2FA) je sigurnosna značajka koja dodaje dodatni sloj zaštite vašem računu. Za prijavu je potrebno koristiti dvije metode, a ne samo korisničko ime i lozinku.",
          "method": {
            "email": "E-mail",
            "emailDesc": "Primajte jednokratne kodove putem e-pošte za dovršetak zahtjeva za autentikaciju.",
            "oath": {
              "add": {
                "button": "Registriraj Authenticator aplikaciju"
              }
            }
          }
        },
        "authenticator": "Authenticator aplikacija",
        "infoFederatedAccount": "Ovim računom upravlja davatelj identiteta vaše organizacije, stoga se lozinka ne može promijeniti ovdje. Da biste promijenili lozinku, prijavite se putem stranice za prijavu vaše organizacije ili se obratite svom IT administratoru.",
        "lastUse": "Zadnje korišteno u {0}.",
        "msg": {
          "invalidPassword": "Pogrešna trenutna lozinka.",
          "passwordAlreadyUsed": "Nije moguće ponovno koristiti zadnjih 5 lozinki.",
          "pwUpdateError": "Došlo je do pogreške pri pokušaju promjene lozinke.",
          "pwUpdated": "Lozinka je promijenjena."
        },
        "noDevice": "Nije konfigurirano",
        "oathAdd": {
          "appInfo": "Kako biste olakšali postupak prijave na STIHL, možete koristiti Authenticator aplikacije poput {0}, {1}, {2} itd. za generiranje jednokratnih lozinki koje se koriste kao drugi faktor tijekom prijave.<br/>Ako ste izgubili ili zaboravili mobilni uređaj, uvijek možete koristiti 2FA kod poslan e-poštom.<br/><br/>Slijedite upute u nastavku da biste postavili svoj uređaj za autentikaciju.",
          "badCode": "Nevažeći kod, pokušajte ponovno.",
          "error": "Došlo je do pogreške pri pokušaju registracije uređaja za autentikaciju.",
          "headScan": "1. Skenirajte QR kod pomoću Authenticator aplikacije",
          "headVerify": "2. Potvrdite kod",
          "infoKey": "Ključ postavljanja",
          "infoKeyTitle": "Vaša dvofaktorska tajna",
          "infoScanBottom": "Ne možete skenirati? Možete koristiti {0} za ručnu konfiguraciju svoje Authenticator aplikacije.",
          "infoVerify": "Unesite kod koji generira vaša Authenticator aplikacija.",
          "success": "Uređaj za autentikaciju je registriran. Sada ga možete koristiti za prijavu.",
          "title": "Registrirajte svoj uređaj za dvofaktorsku autentikaciju"
        },
        "oathDelete": {
          "error": "Došlo je do pogreške pri pokušaju brisanja uređaja za autentikaciju.",
          "success": "Uređaj za autentikaciju je izbrisan."
        },
        "passkeys": {
          "about": {
            "info1": "Passkeys su parovi kriptografskih ključeva (javni i privatni ključ) koje pohranjuje autentikator koji kontrolirate. Autentikator može dokazati da je korisnik prisutan i ovlašten koristiti passkey. Autentikatori dokazuju ovlaštenje pomoću PIN-a, koda, biometrije ili lozinke uređaja, ovisno o mogućnostima i konfiguraciji autentikatora.",
            "info2": "Kada se prijavljujete na STIHL koristeći passkey, vaš autentikator koristi kriptografiju javnog ključa kako bi dokazao vaš identitet bez slanja samog passkeya. Passkeys su vezani za domenu web-mjesta, poput stihl-sso.com, i zahtijevaju sigurnu vezu, što znači da će web preglednik odbiti autentikaciju na lažnoj phishing stranici. Ova svojstva čine passkeys vrlo otpornima na phishing i mnogo težima za napad od SMS-a ili TOTP 2FA.",
            "info3": "Usluge passkey-a podržane u oblaku omogućuju sinkronizaciju passkey-a između uređaja (poput Apple i Android uređaja ili upravitelja lozinki) kako bi se mogli koristiti na više mjesta i bili manje skloni gubitku. Nakon što postavite sinkronizirani passkey na jednom uređaju, taj je passkey dostupan na više uređaja koji koriste istu uslugu.",
            "title": "O passkeyevima"
          },
          "add": {
            "button": "Dodaj novi Passkey",
            "error": "Došlo je do pogreške pri pokušaju dodavanja novog passkeya.",
            "success": "Dodan je novi Passkey."
          },
          "delete": {
            "button": "Izbriši Passkey",
            "error": "Došlo je do pogreške pri pokušaju brisanja ovog passkeya.",
            "success": "Passkey je izbrisan."
          },
          "edit": {
            "error": "Došlo je do pogreške pri pokušaju spremanja naziva passkeya.",
            "name": "Naziv Passkeya",
            "success": "Naziv Passkeya je ažuriran.",
            "title": "Dajte svom Passkeyu naziv kako biste ga razlikovali od ostalih"
          },
          "info": "Passkey je jednostavna i sigurna alternativa lozinkama, koja potvrđuje vaš identitet pomoću dodira, prepoznavanja lica, lozinke uređaja ili PIN-a.",
          "none": "Nema konfiguriranog Passkeya.",
          "reallyDelete": "Jeste li sigurni da želite izbrisati Passkey?",
          "registeredPasskeys": "Vaši registrirani Passkeyi:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Jeste li sigurni da želite izbrisati uređaj za autentikaciju?",
        "secMFA": "Dvofaktorska autentikacija",
        "secPwdChange": "Promijeni lozinku",
        "title": "Sigurnost"
      },
      "setPW": {
        "acceptTC": "Molimo potvrdite naše {terms} i pročitajte našu {privacy}.",
        "killSSO": "Poništi sve aktivne sesije",
        "msg": {
          "tokenExpired": "Poveznica ili kod za lozinku je istekao. Slijedite poveznicu kako biste poništili lozinku: {link}."
        },
        "privacy": "Politika zaštite podataka",
        "terms": "Uvjeti i odredbe",
        "title": "Unesite novu lozinku"
      }
    },
    "validations": {
      "hasDigit": "Mora sadržavati znamenke",
      "hasLowercase": "Mora sadržavati mala slova",
      "hasSpecial": "Mora sadržavati posebne znakove: {chars}",
      "hasUppercase": "Mora sadržavati velika slova",
      "invalidCharacters": "Sadrži nevažeće znakove",
      "maxLength": "Maksimalno dopušteno {max} znakova",
      "minLength": "Minimalno je potrebno {min} znakova",
      "notSameAsEmail": "Previše slično adresi e-pošte",
      "onlyValidCharactersAllowed": "Dopuštena su samo slova, brojevi i razmaci.",
      "required": "Obavezna vrijednost",
      "sameAsPassword": "Lozinke se ne podudaraju",
      "tcAccepted": "Molimo potvrdite naše uvjete i odredbe.",
      "validEmail": "Nevažeća e-mail adresa.",
      "validOTP": "Unesite verifikacijski kod."
    }
  }
}
